import { AddProduct } from "./AddProduct";
import style from "./Admin.module.css";
import { DeleteProduct } from "./DeleteProduct";
import axios from "axios";
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
export const Admin = () => {
  const [validate, setValidate] = useState({
    mail: "",
    pass: "",
  });
  let history = useHistory();

  function handleClick() {
    history.push("/admin/edit");
  }

  const [admin, setAdmin] = useState(false);

  const emailHandler = (e) => {
    setValidate({
      ...validate,
      mail: e.target.value,
    });
  };

  const passHandler = (e) => {
    setValidate({
      ...validate,
      pass: e.target.value,
    });
  };

  const check = () => {
    const admin = {
      admin: validate.mail,
      pass: validate.pass,
    };

    axios
      .post("https://iluminarte3.herokuapp.com/admin/validate2", admin)
      .then((response) => {
        if (response.status === 200) setAdmin(true);
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className={style.ContainerMaster}>
      {admin ? (
        <div className={style.adminLog}>
          <div className={style.Container}>
            {" "}
            <AddProduct></AddProduct>
            <DeleteProduct></DeleteProduct>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              className={style.btn}
              onClick={handleClick}
            >
              Editar Blog
            </Button>
          </div>
        </div>
      ) : (
        <div className={style.ContainerLogin}>
          <label for="email" className={style.label}>
            Email:
          </label>
          <input
            autocomplete="off"
            onChange={emailHandler}
            id="email"
            name="email"
            type="text"
            class
            className={style.input}
          />
          <label for="password" className={style.label}>
            Password:
          </label>
          <input
            autocomplete="off"
            onChange={passHandler}
            id="password"
            name="password"
            type="password"
            className={style.input}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={check}
            className={style.btn}
          >
            Ingresar
          </Button>
        </div>
      )}
    </div>
  );
};

/*    <AddProduct></AddProduct>
     <UpdateProduct></UpdateProduct>
      <DeleteProduct></DeleteProduct>  */
